<template>
  <div class="rightContent">
    <div style="display:none">
        <img :src="require('@/assets/certificate.jpg')" ref="images0" />
        <img :src="require('@/assets/account.png')" ref="images1" />
        <canvas id="mycanvas" width='750' height='530' class="my-canvas"></canvas>
    </div>
    <div class="title">
      累计学习时间：
      <span>{{ "00:00:00".slice(0, 8 - learnHour.length) + learnHour }}</span>
      累计学时：
      <span>{{ learnCredit }}</span>
      <!--ICRD开放注册允许选课后放开注释启动功能，同时放开后端功能20220308byfgq-->
      <button @click="drawPhoto">
        下载证书
      </button>
      <router-link to="/personal/selectCourse" class="button">选课</router-link>
      <button
        @click="
          payTip = true;
          payStatus = false;
        "
      >
        付费
      </button>
      <!--ICRD开放注册允许选课后放开注释启动功能，同时放开后端功能20220308byfgq-->
    </div>
    <div class="table">
      <el-table :data="tableData" border style="width: 990px">
        <el-table-column
          prop="cid"
          label="课程ID"
          width="80"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="cname"
          label="课程名"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="vid"
          label="课时ID"
          width="80"
          align="center"
        ></el-table-column>
        <el-table-column label="课时名" width="250" align="center">
          <template slot-scope="scope">
            {{ scope.row.videoName }}
            <br />
            <!--ICRD学习期间放开注释，启动功能20220308byfgq；技能培训期间也需要打开20220916byfgq-->
            <router-link
              :to="{
                name: 'course',
                params: { id: scope.row.cid + 'c' + scope.row.vid },
              }"
              >点击进入学习</router-link
            > 
            <!--ICRD学习期间放开注释，启动功能20220308byfgq；技能培训期间也需要打开20220916byfgq-->
          </template>
        </el-table-column>
        <el-table-column
          prop="credit"
          label="学时数"
          width="70"
          align="center"
        ></el-table-column>
        <el-table-column label="全部时长" width="84" align="center">
          <template slot-scope="scope">
            {{
              "00:00:00".slice(0, 8 - scope.row.duration.length) +
              scope.row.duration
            }}
          </template>
        </el-table-column>
        <el-table-column label="已学时长" width="84" align="center">
          <template slot-scope="scope">
            {{
              "00:00:00".slice(0, 8 - scope.row.learnDuration.length) +
              scope.row.learnDuration
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="examFinished"
          label="是否完成考核"
          width="110"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.examFinished === null"
              >无考核，视频全部看完即可获得学分</span
            >
            <span v-if="scope.row.examFinished === true">是</span>
            <span v-if="scope.row.examFinished === false">
              否
              <br />
              <!--ICRD学习期间放开注释，启动功能20220308byfgq-->
              <!-- <router-link
                :to="{ name: 'test', params: { id: scope.row.vid + '0000' } }"
                target="_blank"
                >点击进入考核</router-link
              > -->
              <!--ICRD学习期间放开注释，启动功能20220308byfgq-->
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="learnCredit"
          label="已获学时"
          width="81"
          align="center"
        ></el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 30, 100]"
        :page-size="10"
        prev-text="上一页"
        next-text="下一页"
        layout="sizes, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <div id="registerOnly" v-if="payTip">
      <div class="frame" @click.stop>
        <div class="head">
          <img src="/static/logo.png" />
          <span class="zh-remove" @click="payTip = false"></span>
        </div>
        <div class="content" v-if="!payStatus">
          <input type="text" placeholder="请填写剩余学分数量" v-model="scope" />
          <p style="margin-top: 50px; display: inline-block">续费金额</p>
          <span class="selectPay">{{ scope * 15 }}元</span>
          <button @click="_payTip()">立即支付</button>
        </div>
        <div class="content" v-if="payStatus">
          <p style="margin-bottom: 60px; margin-top: 20px; font-size: 16px">
            请在新打开的页面完成支付后,点击下方“已完成”关闭弹框
          </p>
          <button @click="payTip = false">已完成</button>
        </div>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
        <span>请先学满42学时，再点击下载</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible=false">确 定</el-button>
        </span>
    </el-dialog>
    <div id="qrcode" ref="qrcode" style="display:none;"></div>
  </div>
</template>

<script>
import { pageCourseSchedule, baseURL,getInfoMsg,dateInfo } from "@/assets/js/axios.js";
import JsPDF from 'jspdf'
import QRCode from 'qrcodejs2'
export default {
  name: "student",
  data() {
    return {
      page: 1,
      row: 10,
      currentPage: 1,
      total: 0,
      tableData: [],
      learnHour: 0,
      learnCredit: 0,
      payTip: false,
      payStatus: false,
      scope: "",dialogVisible:false,
      info:{
        creditHours:"",
        name:"",
        IDnumber:"",
        awardData:"",
        id:""
      }
    };
  },
  watch: {
    scope(newVal, oldVal) {
      this.scope = newVal.replace(/\D/g, "").substring(0, 3);
    }
  },
  created() {
    let qrcode=new QRCode('qrcode',{
        width:150,
        height:150,
    })
    console.log()
    this._pageCourseSchedule();
  },
  methods: {
    _payTip() {
      window.open(
        baseURL + "/pay/recharge?amount=" + this.scope * 15,
        "_blank"
      );
      this.payStatus = 1;
    },
    handleSizeChange(val) {
      this.row = val;
      this._pageCourseSchedule();
    },
    handleCurrentChange(val) {
      this.page = val;
      this._pageCourseSchedule();
    },
    _pageCourseSchedule() {
      pageCourseSchedule(this.page, this.row).then((res) => {
        this.tableData = res.data.classSchedules;
        this.learnHour = res.data.learnHour;
        this.learnCredit = res.data.learnCredit;
        this.total = res.data.count;
      });
    },
    drawPhoto() {
        if(this.learnCredit<42){
            this.dialogVisible=true
            return 
        }
        let date=new Date()
        date=date.getFullYear()+'-'+('0'+(date.getMonth()+1)).slice(-2)+'-'+('0'+date.getDate()).slice(-2)
        this.info=Object.assign(this.info,dateInfo)
        let id='GDIC'+date.slice(2,4)+('000000'+sessionStorage.getItem('uid')).slice(-6)
        if(new Date().getMonth()+1<7){//更换月份，7是7月；7月前是前一年度的学员，之后是本年度学员；可以改为任意一个月份。
            id='GDIC'+(parseInt(date.slice(2,4))-1)+('000000'+sessionStorage.getItem('uid')).slice(-6)
        }
        for(let i=id.length;i<12;i++){
            id+=parseInt(Math.random()*10)
        }
        getInfoMsg(date,id).then(res=>{
            this.info.startData=res.data.registeredTime.slice(0,10)
            this.info.name=res.data.realName
            this.info.IDnumber=res.data.identityNum
            this.info.awardData=res.data.awardData
            this.info.creditHours=res.data.learnCredit
            this.info.id=res.data.idNumber
            let qr=new QRCode(this.$refs.qrcode,{
                text:"http://guangdong.minisek.com/download?id="+res.data.idNumber,
                width:200,
                height:200,
                margin:10,
                colorDark: "black", //#000000为黑色
                colorLight: "white",
            })
            let pdfImage=function(context,canvas,scalc){
                if(document.querySelector('#qrcode img')){
                    context.drawImage(document.querySelector('#qrcode img'),310*scalc,660*scalc,180*scalc,180*scalc);
                    let pageData = canvas.toDataURL("image/jpg", 1.0*scalc);
                    let PDF = new JsPDF('l','mm','a3')
                    PDF.addImage(pageData,'JPEG',7*scalc,5*scalc,pageData.width,pageData.height)
                    var a = document.createElement("a");
                    a.href = canvas.toDataURL("image/png", 1.0);
                    a.download = "学习证明";
                    a.click();
                }else{
                    setTimeout(()=>{
                        pdfImage(context,canvas)
                    },50)
                }
            }
            setTimeout(()=>{

            
      let canvas = document.getElementById("mycanvas");
      let context = canvas.getContext("2d");
      let scalc=0.85
        canvas.setAttribute("width",1535*scalc)
        canvas.setAttribute("height",1085*scalc)
        console.log(this.$refs.images0)
        context.drawImage(this.$refs.images0,0,0,1535*scalc,1085*scalc);
        context.font = "28px Microsoft YaHei";
        context.fillText(this.info.id, 1160*scalc, 246*scalc);
        context.font = "24px Microsoft YaHei";
        if(this.info.name.length>3){
            context.fillText(this.info.name, 320*scalc, 464*scalc);
        }else{
            context.fillText(this.info.name, 340*scalc, 464*scalc);
        }
        context.fillText(this.info.IDnumber, 612*scalc, 464*scalc);
        context.fillText(this.info.startData.split('-')[0], 958*scalc, 464*scalc);
        context.fillText(this.info.startData.split('-')[1], 1080*scalc, 464*scalc);
        context.fillText(this.info.startData.split('-')[2], 1176*scalc, 464*scalc);
        this.info.endData=this.info.awardData
        context.fillText(this.info.endData.split('-')[0], 288*scalc, 530*scalc);
        context.fillText(this.info.endData.split('-')[1], 413*scalc, 530*scalc);
        context.fillText(this.info.endData.split('-')[2], 506*scalc, 530*scalc);
        this.info.year='20'+this.info.id.slice(4,6)
        context.fillText(this.info.year, 804*scalc, 530*scalc);
        context.fillText(this.info.creditHours, 282*scalc, 596*scalc);
        context.fillText(this.info.awardData.split('-')[0], 1045*scalc, 752*scalc);
        context.fillText(this.info.awardData.split('-')[1], 1156*scalc, 752*scalc);
        context.fillText(this.info.awardData.split('-')[2], 1234*scalc, 752*scalc);
        context.drawImage(this.$refs.images1,1020*scalc,630*scalc,150*scalc,150*scalc);
        context.fillStyle='#ffffff'
        context.fillRect(300*scalc,650*scalc,200*scalc,200*scalc);
        pdfImage(context,canvas,scalc)
            },50)
        })
    }
  }
};
</script>

<style lang="less" scoped>
.rightContent {
  .table {
    /deep/ .el-pagination {
      /deep/ .btn-prev,
      .btn-next {
        min-width: 50px;
      }
    }
     a{
          color: #109eff;
      }
    .title {
      background: #fff;
      height: 46px;
      widows: 984px;
      line-height: 46px;
      padding-left: 26px;
      font-size: 14px;
      color: rgb(102, 102, 102);
      margin-bottom: 12px;
      span {
        color: #1b1f34;
        font-size: 18px;
        padding-right: 26px;
      }
      button {
        font-size: 14px;
        line-height: 22px;
        z-index: 124;
        background: #109eff;
        border: none;
        outline: none;
        color: #fff;
        width: 80px;
        height: 22px;
        border-radius: 4px;
        float: right;
        margin-right: 10px;
        margin-top: 12px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/personal/student.vue